export const pagesConfig = {
  "/dashboard": {
    title: "Dashboard",
    description: "Here’s an overview of all alerts.",
    icon: "homesidebar",
    buttonText: "Watch tutorial",
    videoUrl: "https://www.youtube.com/watch?v=vBIyZCsxwkU"
  },
  "/alerts": {
    title: "Alerts",
    description: "View the status of all alerts.",
    icon: "alerts",
    buttonText: "Watch tutorial",
    videoUrl: "https://www.youtube.com/watch?v=Llzdv1Exymw"
  },
  ...["processors", "subscriptions", "notifications", "mcp", ""].reduce((acc, slug) => {
    acc[slug ? `/integrations/${slug}` : "/integrations"] = {
      title: "Integrations",
      description: "Connect and manage your integrations",
      icon: "integrations",
      buttonText: "Watch tutorial",
      videoUrl: "https://www.youtube.com/watch?v=r6ukXDFhZwk",
      queryParam: "integrations-logs",
      queryButtonText: "View logs"
    }
    return acc
  }, {}),
  "/digital-receipt": {
    title: "Digital receipt",
    description:
      "Helps merchants securely collect, store, and access digital proof of purchase & more.",
    icon: "receipt_bill"
  },
  "/business_settings/integrations": {
    title: "Integrations",
    description: "Integrate your gateway to prevent chargebacks.",
    icon: "integrations",
    buttonText: "Watch tutorial",
    videoUrl: "https://www.youtube.com/watch?v=DQfWiW5ZIbg"
  },
  "/credits": {
    title: "Credits",
    description: "View the status of all credit requests.",
    icon: "alerts"
  },
  "/perks": {
    title: "Perks & Benefits",
    description: "Exclusive deals and discounts from our partners.",
    icon: "gift"
  },
  "/team": {
    title: "Team",
    description: "Manage list of users which business account they can access.",
    icon: "team"
  },
  "/configure/enrollment": {
    title: "Configure",
    description: "View and manage your enrollments and refund settings.",
    icon: "settings"
  },
  "/configure/auto-refund": {
    title: "Configure",
    description: "View and manage your enrollments and refund settings.",
    queryParam: "auto-refund-logs",
    queryButtonText: "View logs"
  },
  "/business_settings/my_business": {
    title: "My Business",
    description: "Manage your business profile and alert rules.",
    icon: "settings",
    buttonText: "Watch tutorial",
    videoUrl: "https://www.youtube.com/watch?v=x4cxRrXFjEk"
  },
  "/business_settings/billing": {
    title: "Billing & Invoices",
    description: "All information about your billing and invoices.",
    icon: "settings"
    //buttonText: "Watch tutorial",
    //videoUrl: "https://www.youtube.com/watch?v=f4RclD3ufD8",
  },
  "/business_settings/balance": {
    title: "Balance & Payment methods",
    description: "All information about your balance and payment methods.",
    icon: "settings"
  },
  "/business_settings/enrollment": {
    title: "Enrollment",
    description: "Turn on your coverage, you will only pay when we prevent a chargeback.",
    icon: "settings",
    buttonText: "Watch tutorial",
    videoUrl: "https://www.youtube.com/watch?v=nVcXJfPOo0U"
  }
}
